import mutations from './userCrud.mutations'
import actions from './userCrud.actions'
import getters from './userCrud.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
